import { IUserModel } from "../../../types/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  userLoaded,
  userLoading,
  userLoadingError,
  setUserFetched,
} from "./userStateActions";
import { PURGE } from "redux-persist";

interface UserState {
  currentUser: IUserModel | null;
  loading: boolean;
  error: string | null;
  hasFetched: boolean;
}

const initialState: UserState = {
  currentUser: null,
  loading: false,
  error: null,
  hasFetched: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => {
      return initialState;
    });
    builder.addCase(userLoading, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(userLoaded, (state, action) => {
      state.loading = false;
      state.currentUser = action.payload;
      state.hasFetched = true;
    });
    builder.addCase(userLoadingError, (state, action) => {
      state.loading = false;
      state.error = "Error loading user";
    });
    builder.addCase(setUserFetched, (state, action) => {
      state.hasFetched = action.payload;
    });
  },
});

export default userSlice.reducer;
